import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fmtPrice } from "../lib/api";
import { getRecentlyViewed } from "../lib/recentlyViewed";
import { handleImgError } from "../lib/imgFallback";

export default function RecentlyViewed({ excludeSlug }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(getRecentlyViewed().filter((p) => p.slug !== excludeSlug).slice(0, 5));
  }, [excludeSlug]);

  if (items.length === 0) return null;

  return (
    <section data-testid="recently-viewed" className="mx-auto max-w-[1500px] px-6 sm:px-10 py-16 border-t border-white/10">
      <h2 className="font-display text-2xl tracking-tight text-[#F5F5F5] mb-8">Recently Viewed</h2>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {items.map((p) => (
          <Link key={p.slug} to={`/products/${p.slug}`} data-testid={`recent-${p.slug}`} className="group bg-[#1F1F1F] border border-white/[0.06] hover:border-[#4ADE80]/40 transition-colors">
            <div className="aspect-square overflow-hidden bg-[#0F0F10]">
              <img src={p.image} alt={p.name} loading="lazy" onError={handleImgError} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-4">
              <h3 className="font-display text-[13px] text-[#F5F5F5] truncate group-hover:text-[#4ADE80] transition-colors">{p.name}</h3>
              <span className="text-[12px] text-[#A8A8A8]">{fmtPrice(p.price)}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
